import { useMemo } from "react";
import { Card, ErrorState, Loading, Metric, PageIntro, stableArray, useLoader } from "./shared";
import { useAppNavigation } from "../layout";

function flatten(nodes, result = []) {
  stableArray(nodes).forEach((node) => {
    result.push(node);
    flatten(node.filhos, result);
  });
  return result;
}

function progressStatus(node) {
  if (node.status) return node.status;
  const children = stableArray(node.filhos);
  if (!children.length) return "todo";
  const statuses = children.map(progressStatus);
  return statuses.every((status) => status === "done") ? "done" : statuses.every((status) => status === "todo") ? "todo" : "partial";
}

function statusLabel(status) {
  if (status === "done") return "Concluído";
  if (status === "partial") return "Em evolução";
  return "Planejado";
}

export function ApplicationsPage() {
  const { navigate } = useAppNavigation();
  return <div className="screen applications-screen">
    <PageIntro eyebrow="AMBIENTES AUTUS" title="CFO Autus" description="Seu ambiente de inteligência financeira está pronto para transformar dados em decisões." />
    <section className="application-launch-card">
      <div className="application-launch-mark"><span>CFO</span><strong>Autus</strong></div>
      <div>
        <span className="status-chip positive">Disponível</span>
        <h2>Inteligência financeira executiva</h2>
        <p>Acompanhe performance, balanço, indicadores e a execução das decisões em uma única experiência.</p>
      </div>
      <button className="button primary" type="button" onClick={() => navigate("/dashboard")}>Abrir ambiente</button>
    </section>
  </div>;
}

export function DevelopmentMapPage() {
  const roadmap = useLoader(async () => {
    const response = await fetch("/api/mapa", { credentials: "include" });
    if (!response.ok) throw new Error("Não foi possível carregar o mapa de evolução.");
    return response.json();
  }, []);
  const snapshot = useMemo(() => {
    const leaves = flatten(roadmap.data?.raiz?.filhos).filter((node) => !stableArray(node.filhos).length);
    const grouped = { done: [], partial: [], todo: [] };
    leaves.forEach((node) => grouped[progressStatus(node)]?.push(node));
    return { leaves, grouped };
  }, [roadmap.data]);
  const total = snapshot.leaves.length || 1;

  return <div className="screen development-map-screen">
    <PageIntro eyebrow="EVOLUÇÃO DO PRODUTO" title={roadmap.data?.titulo || "Mapa de desenvolvimento"} description="Visão objetiva das entregas concluídas, em evolução e planejadas." />
    {roadmap.loading && <Loading label="Carregando mapa de evolução…" />}
    {roadmap.error && <ErrorState message={roadmap.error} onRetry={roadmap.reload} />}
    {roadmap.data && <>
      <section className="metric-grid progress-metrics">
        <Metric label="Entregas concluídas" value={snapshot.grouped.done.length} helper={`${Math.round((snapshot.grouped.done.length / total) * 100)}% do escopo mapeado`} tone="positive" />
        <Metric label="Em evolução" value={snapshot.grouped.partial.length} helper="Frentes ativas de produto" tone="warning" />
        <Metric label="Planejadas" value={snapshot.grouped.todo.length} helper="Próximas capacidades" tone="neutral" />
      </section>
      <Card title="Frentes de evolução" subtitle={roadmap.data.atualizado ? `Atualizado em ${roadmap.data.atualizado.split("-").reverse().join("/")}` : undefined}>
        <div className="development-columns">
          {["done", "partial", "todo"].map((status) => <section className={`development-column ${status}`} key={status}>
            <header><span className="status-dot" /><h3>{statusLabel(status)}</h3><small>{snapshot.grouped[status].length}</small></header>
            <div>{snapshot.grouped[status].slice(0, 12).map((item) => <article key={item.id} className="development-item"><strong>{item.nome}</strong>{item.nota && <p>{item.nota}</p>}</article>)}{!snapshot.grouped[status].length && <p className="kanban-empty">Nenhum item nesta etapa</p>}</div>
          </section>)}
        </div>
      </Card>
    </>}
  </div>;
}
